import './styles/index.css'
import '@fontsource/dm-sans/index.css'
import 'react-tabs/style/react-tabs.css'
import './bootstrap'

import { createWeb3ReactRoot, Web3ReactProvider } from '@web3-react/core'
import { KashiProvider } from 'kashi'
import React, {StrictMode, useEffect, useState} from 'react'
import { isMobile } from 'react-device-detect'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import Blocklist from './components/Blocklist'
import { NetworkContextName } from './constants'
import App from './pages/App'
import store from './state'
import ApplicationUpdater from './state/application/updater'
import ListsUpdater from './state/lists/updater'
import MulticallUpdater from './state/multicall/updater'
import TransactionUpdater from './state/transactions/updater'
import UserUpdater from './state/user/updater'
import ThemeProvider, { ThemedGlobalStyle } from './theme'
import getLibrary from './utils/getLibrary'
import LanguageProvider from 'language'
import axios from "axios";
import { useCookies } from "react-cookie";

const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName)

if (!!window.ethereum) {
    window.ethereum.autoRefreshOnNetworkChange = false
}

const GOOGLE_ANALYTICS_ID: string | undefined = process.env.REACT_APP_GOOGLE_ANALYTICS_ID
if (typeof GOOGLE_ANALYTICS_ID === 'string') {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID)
    ReactGA.set({
        customBrowserType: !isMobile
            ? 'desktop'
            : 'web3' in window || 'ethereum' in window
            ? 'mobileWeb3'
            : 'mobileRegular'
    })
} else {
    ReactGA.initialize('test', { testMode: true, debug: true })
}

window.addEventListener('error', error => {
    ReactGA.exception({
        description: `${error.message} @ ${error.filename}:${error.lineno}:${error.colno}`,
        fatal: true
    })
})

function Updaters() {
    return (
        <>
            <ListsUpdater />
            <UserUpdater />
            <ApplicationUpdater />
            <TransactionUpdater />
            <MulticallUpdater />
        </>
    )
}

/** ##### **/

const access_token: string = getCookie({cname: 'access_token'});

const loginCheck = async () => {
    let apiFlag = false;
    if(window.location.href === "https://t-bitin.io/batch"){
        apiFlag = true;
    }

    axios.get("https://auth.t-bitin.io/api/token?token=" + access_token)
        .then(res => {

            if((!res.data.response || res.data.login === "false") && !apiFlag) {
                window.location.replace('https://auth.t-bitin.io');
            }else {

                ReactDOM.render(
                    <StrictMode>
                        <Web3ReactProvider getLibrary={getLibrary}>
                            <Web3ProviderNetwork getLibrary={getLibrary}>
                                <Blocklist>
                                    <Provider store={store}>
                                        <Updaters/>
                                        <LanguageProvider>
                                            <ThemeProvider>
                                                <ThemedGlobalStyle/>
                                                <KashiProvider>
                                                    <Router>
                                                        <App/>
                                                    </Router>
                                                </KashiProvider>
                                            </ThemeProvider>
                                        </LanguageProvider>
                                    </Provider>
                                </Blocklist>
                            </Web3ProviderNetwork>
                        </Web3ReactProvider>
                    </StrictMode>,
                    document.getElementById('root')
                )
            }
        })
}

loginCheck()

function getCookie({cname}: { cname: any }) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
/** ##### **/


